module.exports = __webpack_public_path__ + "img/ts.c8f105d3.png";